import React, { useMemo, useState, useEffect } from "react";
import styled from "styled-components";
import { makeStyles } from "@material-ui/core/styles";
import DocumentForm from "./forms/DocumentForm";
import { useSelector } from "react-redux";
import MaterialTable from "material-table";
import ConfirmDialog from "./ConfirmDialog";
import useTable from "./useTable";
import AttachFileIcon from "@material-ui/icons/AttachFile";
import TransferPicturesForm from "./forms/TransferPicturesForm";
import moment from "moment";
import { Paper, Fab, TextField, MenuItem, IconButton } from "@material-ui/core";
import Popup from "./Popup";
import Button from "./controls/Button";
import Api from "../lib/api";
import Iconify from "./Iconify.js";
import CRMUtils from "../utils/index.js";

import { isEmpty, findIndex } from "lodash";
import MTable from "../components_generic/MTableR";

const Wrapper = styled.div`
  padding: ${(props) => props.theme.spacing(1) / 4}px
    ${(props) => props.theme.spacing(4)}px;
  flex-direction: column;
  display: flex;
  height: 100%;
`;

const useStyles = makeStyles((theme) => ({
  paper: {
    padding: "6px 16px",
    flexGrow: 1,
  },
  form: {
    justifySelf: "self-end",
  },
  newButton: {
    position: "absolute",
    right: "10px",
  },
  wrapText: {
    whiteSpace: "normal",
    wordWrap: "break-word",
    maxWidth: "100px",
  },
}));

function DocumentsSummary(props) {
  const { authUser } = useSelector((state) => state.auth);
  const [types, setTypes] = useState([]);
  const classes = useStyles();

  const {
    documents,
    documentTypes,
    onSave,
    onDeleteDocument,
    onTransferDocument,
    showDelete,
    canAdd = true,
    canEdit = true,
    canDelete = true,
    enableCamera = false,
    rReadonly = false,
  } = props;

  const [dataMaterialTable, setDataMaterialTable] = useState(
    documents.map((o) => ({ ...o }))
  );
  const [documentForEdit, setDocumentForEdit] = useState(null);
  const [documentName, setDocumentName] = useState(
    documentForEdit ? documentForEdit.name : ""
  );
  const [openTransfer, setOpenTransfer] = useState(false);

  const [openPopupEdit, setOpenPopupEdit] = useState(false);

  const [dforEdit, setDforEdit] = useState(null);

  const checkIfImage = (mimeType) => {
    if (mimeType) {
      return mimeType.startsWith("image");
    }
    return false;
  };

  const userCanEditDocument = CRMUtils.userHasPermission(authUser, [
    "user_editcontactdocuments",
  ]);

  const userCanTransferDocument = CRMUtils.userHasPermission(authUser, [
    "document_transfer",
  ]);

  const [init, setInit] = useState(true);
  const [recordproducts, setRecordproducts] = useState([]);

  const editDocummentName = async () => {
    var payload = { name: documentName };
    const { data } = await Api.updateContactDocumment(payload, dforEdit?.id);

    if (data && data.data) {
      const index = findIndex(documentstoshow, ["id", data.data.id]);

      if (index >= 0) {
        const entity = { ...documentstoshow[index], ...data.data };
        let entities = [...documentstoshow];
        entities[index] = entity;

        setdocumentstoshow([...entities]);
        setDataMaterialTable([...entities]);
      }
    }

    onCloseEdit();
  };

  const canUserViewTheDocument = (documentType = "", documentID = null) => {
    if (documentType && documentID) {
      var cleanName = documentType
        .replaceAll(" ", "")
        .replaceAll("_", "")
        .toLowerCase();

      return CRMUtils.userHasPermission(authUser, [
        "doctypesview_" + cleanName + "_" + documentID,
      ]);
    } else {
      return true;
    }
  };

  const headCellsMaterial = [
    {
      field: "type",
      title: "Type",
      width: "15%",
      render: (rowData) => {
        return rowData.collection_name;
      },
    },
    {
      field: "name",
      title: "Name",
      width: "20%",
      render: (rowData) => {
        return <div className={classes.wrapText}>{rowData.name}</div>;
      },
    },
    {
      field: "uploaded_by",
      title: "Uploaded By",
      width: "15%",
    },

    {
      field: "created_at",
      title: "Created",
      width: "12%",
      render: (rowData) => {
        return rowData.created_at
          ? moment(rowData.created_at).format("YYYY-MM-DD")
          : "";
      },
    },
    {
      field: "file",
      title: "File",
      width: "8%",

      render: (rowData) =>
        rowData.url && !rReadonly ? (
          canUserViewTheDocument(rowData.doc_type_name, rowData.doc_type_id) ? (
            <a href={rowData.url} target="_blank" rel="noreferrer">
              <AttachFileIcon />
            </a>
          ) : (
            <AttachFileIcon style={{ color: "#999999" }} />
          )
        ) : (
          ""
        ),
    },
    {
      field: "model",
      title: "From",
      width: "12%",
    },
  ];

  const onClickEdit = (rowData) => {
    setDforEdit(rowData);
    setOpenPopupEdit(true);
  };
  const onClickTransfer = (rowData) => {
    setDforEdit(rowData);
    setOpenTransfer(true);
  };

  const onCloseEdit = () => {
    setOpenPopupEdit(false);
    setDforEdit(null);
  };

  const onCloseTransfer = () => {
    setOpenTransfer(false);
    setDforEdit(null);
  };

  const getRecordProducts = async () => {
    const { data } = await Api.getRecordProductsFromDocuments(
      documentstoshow[0].id
    );

    if (data && data.data) {
      setRecordproducts(data.data);
    }
  };

  const onTransferPictures = async (info) => {
    const payload = {
      record_products: info.record_products,
      transfer_to: info.transfer_to,
    };

    if (info?.position) {
      payload.position = info.position;
    }

    if (info?.type) {
      payload.type = info.type;
    }

    const { data } = await Api.onTransferPictures(dforEdit?.id, payload);

    if (data && data.data) {
      if (typeof onTransferDocument === "function") {
        console.log(dforEdit?.id);
        onTransferDocument(dforEdit?.id);
      }

      onCloseTransfer();
    }
  };

  const [documentstoshow, setdocumentstoshow] = useState([]);
  const [selected, setSelected] = useState([]);
  const [openPopup, setOpenPopup] = useState(false);
  const [filterValue, setFilterValue] = useState("All Documents");
  const handleClick = (event, id) => {
    const selectedIndex = selected.indexOf(id);
    let newSelected = [];

    if (selectedIndex === -1) {
      newSelected = newSelected.concat(selected, id);
    } else if (selectedIndex === 0) {
      newSelected = newSelected.concat(selected.slice(1));
    } else if (selectedIndex === selected.length - 1) {
      newSelected = newSelected.concat(selected.slice(0, -1));
    } else if (selectedIndex > 0) {
      newSelected = newSelected.concat(
        selected.slice(0, selectedIndex),
        selected.slice(selectedIndex + 1)
      );
    }

    setSelected(newSelected);
  };
  const [notify, setNotify] = useState({
    isOpen: false,
    message: "",
    type: "",
  });
  const [confirmDialog, setConfirmDialog] = useState({
    isOpen: false,
    title: "",
    subTitle: "",
  });
  const isSelected = (id) => selected.indexOf(id) !== -1;

  const { TblContainer } = useTable();

  const openInPopup = (item) => {
    setOpenPopup(true);
  };

  const onClose = () => {
    setOpenPopup(false);
  };

  const onDelete = async (id) => {
    const orgId = authUser.organization_id;
    onDeleteDocument(orgId, id);

    setConfirmDialog({
      ...confirmDialog,
      isOpen: false,
    });

    setNotify({
      isOpen: true,
      message: "Deleted Successfully",
      type: "error",
    });
  };

  useEffect(() => {
    setdocumentstoshow(documents);
    setDataMaterialTable(documents.map((o) => ({ ...o })));
  }, [documents]);

  var docTypes = [];

  useEffect(() => {
    if (documentstoshow && types.length == 0) {
      var id = 0;
      documentstoshow?.map((a) => {
        var index = docTypes.filter((g) => a.collection_name == g.title);
        //  console.log("INDEX", index);
        if (index.length == 0) id += 1;
        return index.length == 0
          ? docTypes.push({ id: id, title: a.collection_name })
          : "";
      });
      setTypes([...docTypes]);
      //  console.log("DOCTYPES: ", docTypes);
    }

    if (init && !isEmpty(documentstoshow)) {
      setInit(!init);
      getRecordProducts();
    }
  }, [documentstoshow]);

  const saveDocument = (data) => {
    onSave(data);
    onClose();
  };

  const handleTabChange = (event, newValue) => {
    setTabValue(newValue);
  };

  function a11yProps(index) {
    return {
      id: `simple-tab-${index}`,
      "aria-controls": `simple-tabpanel-${index}`,
    };
  }

  const filterDocumments = (documents, type) => {
    if (type == "All Documents") {
      setDataMaterialTable([...documents]);
    } else {
      setDataMaterialTable(
        documents
          ? documents
              .filter((a) => a.collection_name == type)
              .map((o) => ({ ...o }))
          : []
      );
    }
  };
  const tableActions = [
    {
      icon: () => (
        <Fab color="primary" aria-label="add">
          <Iconify icon={"fluent:add-12-filled"} width={25} height={25} />
        </Fab>
      ),
      tooltip: "Attach document",
      disabled: !canAdd || rReadonly,
      hidden: !canAdd || rReadonly,
      isFreeAction: true,
      onClick: (event) => openInPopup(),
    },
    (rowData) => ({
      icon: () => (
        <IconButton
          aria-controls={`action-menu1-${rowData.tableData.id}`}
          aria-haspopup="true"
          onClick={(event) => onClickTransfer(rowData)}
          style={{
            color:
              !userCanTransferDocument ||
              rReadonly ||
              !checkIfImage(rowData?.mime_type) ||
              !canUserViewTheDocument(
                rowData?.doc_type_name,
                rowData?.doc_type_id
              )
                ? "#bdbdbd"
                : "#2196f3",
          }}
        >
          <Iconify
            icon={"mingcute:transfer-fill"}
            width={20}
            height={20}
            style={{
              color:
                !userCanTransferDocument ||
                rReadonly ||
                !checkIfImage(rowData?.mime_type) ||
                !canUserViewTheDocument(
                  rowData?.doc_type_name,
                  rowData?.doc_type_id
                )
                  ? "#bdbdbd"
                  : "#2196f3",
            }}
          />
        </IconButton>
      ),
      tooltip: "Transfer",
      disabled:
        !userCanTransferDocument ||
        rReadonly ||
        !checkIfImage(rowData?.mime_type) ||
        !canUserViewTheDocument(rowData?.doc_type_name, rowData?.doc_type_id),
    }),

    (rowData) => ({
      icon: () => (
        <IconButton
          aria-controls={`action-menu1-${rowData.tableData.id}`}
          aria-haspopup="true"
          onClick={(event) => onClickEdit(rowData)}
          style={{
            color:
              !userCanEditDocument ||
              rReadonly ||
              !canUserViewTheDocument(
                rowData?.doc_type_name,
                rowData?.doc_type_id
              )
                ? "#bdbdbd"
                : "#009688",
          }}
        >
          <Iconify
            icon={"fluent:edit-24-filled"}
            width={20}
            height={20}
            style={{
              color:
                !userCanEditDocument ||
                rReadonly ||
                !canUserViewTheDocument(
                  rowData?.doc_type_name,
                  rowData?.doc_type_id
                )
                  ? "#bdbdbd"
                  : "#009688",
            }}
          />
        </IconButton>
      ),
      tooltip: "Edit",

      disabled:
        !userCanEditDocument ||
        rReadonly ||
        !canUserViewTheDocument(rowData?.doc_type_name, rowData?.doc_type_id),
    }),

    (rowData) => ({
      icon: () => (
        <IconButton
          aria-controls={`action-menu1-${rowData.tableData.id}`}
          aria-haspopup="true"
          onClick={(event) =>
            setConfirmDialog({
              isOpen: true,
              title: "Are you sure to delete this document?",
              subTitle: "You can't undo this operation",
              onConfirm: () => onDelete(rowData?.id),
            })
          }
          style={{
            color:
              !showDelete ||
              !canDelete ||
              rReadonly ||
              !canUserViewTheDocument(
                rowData?.doc_type_name,
                rowData?.doc_type_id
              )
                ? "#bdbdbd"
                : "#f44336",
          }}
        >
          <Iconify
            icon={"mingcute:delete-fill"}
            width={20}
            height={20}
            style={{
              color:
                !showDelete ||
                !canDelete ||
                rReadonly ||
                !canUserViewTheDocument(
                  rowData?.doc_type_name,
                  rowData?.doc_type_id
                )
                  ? "#bdbdbd"
                  : "#f44336",
            }}
          />
        </IconButton>
      ),
      tooltip: "Delete",

      disabled:
        !showDelete ||
        !canDelete ||
        rReadonly ||
        !canUserViewTheDocument(rowData?.doc_type_name, rowData?.doc_type_id),
    }),
  ];

  return (
    <Wrapper>
      {/* <Paper elevation={1} className={classes.paper}> */}
      {/* <TblContainer> */}
      <TextField
        style={{
          marginRight: 6,
          maxWidth: 160,
          minWidth: 50,
          position: "relative",
          top: 70,
          left: 125,
          zIndex: 1,
        }}
        variant="outlined"
        defaultValue={filterValue}
        label="Types"
        onChange={(value) => {
          setFilterValue(value.target.value);
          filterDocumments(documentstoshow, value.target.value);
        }}
        select
      >
        <MenuItem key={0} value="All Documents">
          All Documents
        </MenuItem>
        {types.map((item) =>
          item.title != null ? (
            <MenuItem key={item.id} value={item.title}>
              {item.title}
            </MenuItem>
          ) : (
            <MenuItem key={item.id} value={item.title}>
              {item.name}
            </MenuItem>
          )
        )}
      </TextField>
      <MTable
        columns={headCellsMaterial}
        data={dataMaterialTable}
        actions={tableActions}
        pageSize={10}
        pageSizeOptions={[5, 10, 15, 20, 50]}
        exportButton={false}
        search
        toolbar
        showPaging
        showTitle
        title="Documents"
        headerStyle={{
          backgroundColor: "#e0f2f1",
          color: "#00695c",
        }}
        optionstoAdd={{
          tableLayout: "fixed",
        }}
       
        emptyRowsWhenPaging={false}
 
      />

      {/* <MaterialTable
          style={{ marginTop: -45 }}
          columns={headCellsMaterial}
          data={dataMaterialTable}
          actions={tableActions}
          options={{
            tableLayout: "fixed",
            pageSize: 10, // make initial page size
            emptyRowsWhenPaging: false, //to make page size fix in case of less data rows
            actionsColumnIndex: -1,
            headerStyle: {
              backgroundColor: "#e0f2f1",
              color: "#00695c",
            },
          }}
          title="Documents"
        /> */}
      {/* </TblContainer> */}
      {/* </Paper> */}
      <Popup
        title={"Attach document"}
        fullWidth={true}
        openPopup={openPopup}
        onClose={onClose}
      >
        <DocumentForm
          saveDocument={saveDocument}
          documentTypes={documentTypes}
          className={classes.form}
          enableCamera={enableCamera}
        />
      </Popup>
      <ConfirmDialog
        confirmDialog={confirmDialog}
        setConfirmDialog={setConfirmDialog}
      />

      <Popup
        maxWidth="md"
        title={`Transfer Picture ${dforEdit?.name}`}
        fullWidth={true}
        openPopup={openTransfer}
        onClose={onCloseTransfer}
      >
        <TransferPicturesForm
          onTransferPictures={onTransferPictures}
          recordproducts={recordproducts}
        />
      </Popup>

      <Popup
        maxWidth={"xs"}
        title={"Edit Document"}
        fullWidth={true}
        openPopup={openPopupEdit}
        onClose={onCloseEdit}
      >
        <div style={{ display: "flex" }}>
          <TextField
            onChange={(e) => {
              setDocumentName(e.target.value);
            }}
            style={{ width: "100%" }}
            label="Documment Name"
            variant="outlined"
            defaultValue={dforEdit?.name || ""}
          ></TextField>
          <Button
            text={"Submit"}
            onClick={() => {
              editDocummentName();
            }}
          />
        </div>
      </Popup>
    </Wrapper>
  );
}

export default DocumentsSummary;
